import React, { useCallback } from 'react'
import List from '@commonComponents/List'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import CcDocForm from '@EUForms/ccDocForm'
import { Checkbox } from 'semantic-ui-react'
import { useDispatch, useSelector } from 'react-redux'
import { selectHeaderTabDS } from '@EUForms/selectors'
import { updateShipmentFieldValue } from '../../reducer/headerSlice'
import { useEvent } from '@hooks/useEvent'

const CCDocDetail = ({ dataSource, ...rest }) => {
  const isCCDocEndRequest = useSelector(selectHeaderTabDS).isCCDocEndRequest || '0'
  const {isDisabled} = useCurrentShipmentType()
  const dispatch = useDispatch()
  const { saveForm } = useEvent('headerTab')
  const renderItem = useCallback(
    ({ id, ...restItem }) => <CcDocForm key={id} dataSource={{ id, ...restItem }} {...rest} />,
    [dataSource]
  )

  return (
    <div style={{position:'relative'}}>
      <List className='responsiveGridCss' dataSource={dataSource} renderItem={renderItem} />
      {dataSource?.length>0 && <Checkbox
        label='Is end request!'
        value={isCCDocEndRequest}
        disabled={isDisabled}
        checked={isCCDocEndRequest === '1'}
        onChange={() => {
          if (isCCDocEndRequest === '0') {
            dispatch(updateShipmentFieldValue({ isCCDocEndRequest: '1' }))
            saveForm({ isCCDocEndRequest: '1' })
          }
        }}
        style={{ borderRadius: 0, position: 'absolute', right:'2rem' , marginTop: '1rem' }}
      />}
    </div>
  )
}

export default React.memo(CCDocDetail)
